/** Created by azhou on 2019/3/11.*/
<template>
  <div>
    <ul class="list-item" v-if="storeInfo.type===2">
      <li class="list-item-col"><el-checkbox v-model="Itemize.checked" class="mr-2"/></li>
      <li class="w-50 list-item-col">{{Itemize.storeName}}
        <el-popover placement="right" trigger="hover">
          {{Itemize.order_no}}
          <span class="text-info" slot="reference"><i class="el-icon-info text-info"></i></span>
        </el-popover>
      </li>
      <li class="w-50 list-item-col">{{Itemize.payMoney/100 | formatMoney}} 元</li>
      <li class="w-50 list-item-col">{{Itemize.payTime | formatTimestamp(1)}}</li>
      <li class="w-50 list-item-col">{{Itemize.remaidMoney/100 | formatMoney}} 元</li>
      <li class="w-50 list-item-col">{{Itemize.availableMoney/100 | formatMoney}} 元</li>
    </ul>
    <ul class="list-item" v-else>
      <li class="list-item-col"><el-checkbox v-model="Itemize.checked" class="mr-2"/></li>
        <li class="w-50 list-item-col" v-if="storeInfo.type == 3">
          <el-popover placement="right" trigger="hover">
            <div>预订单位：{{Itemize.company}}</div>
            <p>入住日期：{{Itemize.date_in | formatTimestamp}} 至 {{Itemize.date_out | formatTimestamp}}</p>
            <p>订单号：{{Itemize.order_no}}</p>
            <div slot="reference">
              <div class="mb-1">{{Itemize.company | formatString(8)}}</div>
              <div class="text-link" @click="goOrderDetail">{{Itemize.title | formatString(8)}}</div>
            </div>
          </el-popover>
        </li>
        <li class="w-100 list-item-col flex-column" v-if="$GFUN.isInArray([5,6,8],storeInfo.type)">
          <div>{{Itemize.company}}</div>
          <div>
            {{Itemize.date_in | formatTimestamp}}
            <span v-if="storeInfo.type == 5"> ~ {{Itemize.date_out | formatTimestamp}}</span>
          </div>
          <div class="text-link breakword" @click="goOrderDetail">{{Itemize.order_no}}</div>
        </li>
        <li class="w-50 list-item-col">
          &yen; {{Itemize.total_price}}
          <el-popover placement="right" trigger="hover" v-if="!$GFUN.isInArray([6,8],storeInfo.type)" class="ml-1 h7">
            <p v-if="storeInfo.type===3">订金：&yen; {{Itemize.deposit}} 元</p>
            <p>尾款：&yen; {{Itemize.finalPrice | formatMoney}} 元</p>
            <p>续住：&yen; {{Itemize.continued_price}} 元</p>
            <span slot="reference"><i class="el-icon-info text-info"></i></span>
          </el-popover>
        </li>
        <li class="w-50 list-item-col" v-if="!$GFUN.isInArray([6,8],storeInfo.type)">
          &yen; {{Itemize.total_pay}}
          <el-popover placement="right" trigger="hover" class="ml-1 h7">
            <p v-if="storeInfo.type===3">订金：&yen; {{Itemize.deposit_pay}}</p>
            <p>尾款：&yen; {{Itemize.finalPay | formatMoney}}</p>
            <p>续住：&yen; {{Itemize.continued_pay}}</p>
            <span slot="reference"><i class="el-icon-info text-info"></i></span>
          </el-popover>
        </li>
        <li class="w-50 list-item-col">&yen; {{Itemize.withdraw_money}}</li>
        <li class="w-50 list-item-col flex-column">
          <div>&yen; {{Itemize.freeze_money}}</div>
          <div class="text-muted h7 mt-1" v-show="Itemize.freeze_money > 0">（处理中...）</div>
        </li>
        <li class="w-50 list-item-col">&yen; {{Itemize.in_withdraw_money}}</li>
        <li class="w-50 list-item-col">
          &yen; {{Itemize.no_withdraw_money}}
          <el-popover placement="right" trigger="hover" class="ml-1" v-show="Itemize.no_withdraw_money !== '0.00'"
                      :content="Itemize.remark || '无相关信息'">
            <span slot="reference"><i class="el-icon-info text-info"></i></span>
          </el-popover>
        </li>
        <li class="w-50 list-item-col">&yen; {{Itemize.commision_price}}
          <el-popover placement="right" trigger="hover" class="ml-1" v-show="Itemize.commision_price > 0">
            <p>佣金比例：{{Itemize.commision * 100}}%</p>
            <p>手续费：{{Itemize.poundage}}元</p>
            <span slot="reference"><i class="el-icon-info text-info"></i></span>
          </el-popover>
        </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ItemizeWithdrawOperate',
    props:{
      Itemize:{}
    },
    computed:{
      ...mapGetters(['storeInfo']),
    },
    methods:{
      goOrderDetail() {
        let routeUrl = this.$router.resolve({
          name: 'OrderDetail',
          query: {
            orderType: this.storeInfo.type,
            orderId: this.Itemize.oid,
            storeId: this.Itemize.store_id || this.Itemize.appoint,
            status: this.Itemize.status,
            GST: this.$route.query.GST
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    }
  }
</script>
